import { AcquisitionStatus } from "types/acquisition";
import * as Yup from "yup";
import i18n from "i18n";

export interface Inputs {
  title: string;
  material: string;
  placeOfAcquisition: string;
  status: AcquisitionStatus[] | string[];
  startDate: Date | null;
  endDate: Date | null;
}

export const validationSchema = Yup.object({
  title: Yup.string(),
  material: Yup.string(),
  placeOfAcquisition: Yup.string(),
  status: Yup.array().of(Yup.mixed().oneOf(Object.values(AcquisitionStatus))),
  startDate: Yup.date().typeError(i18n.t("Invalid Date")).nullable(),
  endDate: Yup.date()
    .nullable()
    .typeError(i18n.t("Invalid Date"))
    .test(
      "End date must come after start date",
      "End date must come after start date",
      function () {
        if (!this.parent.startDate || !this.parent.endDate) return true;
        return this.parent.startDate.getTime() <= this.parent.endDate.getTime();
      }
    ),
});

export const initialValues = {
  title: "",
  material: "",
  placeOfAcquisition: "",
  status: [],
  startDate: null,
  endDate: null,
};
